// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"53":"webfontloader","592":"course","594":"about","597":"projects","966":"login"}[chunkId] + "." + {"53":"e0d14079","592":"e8205c4b","594":"8258cc21","597":"febf2754","966":"c039a038"}[chunkId] + ".js";
};